import { toast } from 'sonner';

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success('Скопировано в буфер обмена');
  } catch (err) {
    console.error('Failed to copy:', err);
    toast.error('Не удалось скопировать в буфер обмена');
  }
};
